import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'hooks/use-redux'
import { loadBusinessSubscription } from '@disco/state-management/actions/UserActions'
import CardNumber from './CardNumber'

/**
 * CardNumberContainer component for managing card number data
 *
 * Container component that handles loading business subscription data and
 * passes it to the CardNumber component for display.
 *
 * @returns JSX element containing the card number display
 */
const CardNumberContainer = (): React.ReactNode => {
  const dispatch = useDispatch()
  const subscription = useSelector(state => state.subscription)
  useEffect(() => {
    if (!subscription.loading && !subscription.loaded) {
      dispatch(loadBusinessSubscription())
    }
  }, [])
  return <CardNumber subscription={subscription} />
}

export default CardNumberContainer
